'use strict';

angular.module('shop').controller('CheckoutController', function($rootScope, $scope, $window, $timeout, $state, ShopService, Toast, LANG) {
	$scope.cart = ShopService.getCart();

	if (!$scope.cart ||  $scope.cart.cartArticles.length === 0) {
		$scope.emptyCart = true;
		return;
	}
	
	$scope.loading = true;

	$scope.input = {};

	if ($scope.cart.giftCode || $scope.cart.giftCode !== '') {
		$scope.input.giftcard = $scope.cart.giftCode;
	}

	$scope.getSummary = function(useLoyaltyPoints) {
		$scope.loading = true;

		$scope.cart.useLoyaltyPoints = useLoyaltyPoints;

		ShopService.getSummary($scope.cart).then(function(summary) {
	
			if (!summary.summaryArticles || summary.summaryArticles.length === 0) {
				$scope.emptyCart = true;
				$scope.loading = false;
				return;
			}

			if (summary.summaryArticles && summary.summaryArticles.length > 0) {
				_.each(summary.summaryArticles, function(article) {
					article.product = _.find($scope.cart.cartArticles, {shopArticleID: article.shopArticleID});
				});
			}

			if (summary.giftCodePrice > 0) {
				$scope.giftcard = true;
			}

			summary.formatedDeliveryDate = moment(summary.deliveryDate).locale(LANG).format('dddd D MMMM');

			$scope.summary = summary;
			$scope.loading = false;
		
		});
	};

	$scope.getSummary(false);
	
	$scope.useGiftCard = function(code) {
		$scope.cart.giftCode = code;
		ShopService.setCart($scope.cart);
	};

	$scope.removeGiftcard = function() {
		$scope.cart.giftCode = '';
		$scope.input.giftcard = '';
		$scope.giftcard = false;
		ShopService.setCart($scope.cart);
	};

	$scope.removeArticle = function(article) {
		var articleIndex = _.findIndex($scope.cart.cartArticles, {shopArticleID: article.shopArticleID});

		if (articleIndex !== -1) {
			$scope.cart.cartArticles.splice(articleIndex, 1);

			ShopService.setCart($scope.cart);
		}
	};

	$scope.order = function() {
		$scope.unvalidZipcode = false;

		$scope.cart = ShopService.getCart();

		if (!$scope.cart || !$scope.cart.cartArticles || $scope.cart.cartArticles.length === 0) {
			$scope.emptyCart = true;
			return;
		}

		if (!$scope.cart.validZipcode) {
			$rootScope.$emit('shop-zipcode.check');
		}

		$state.go('account');
	};

	$rootScope.$on('shop-cart.clear', function() {
		$scope.emptyCart = true;
	});

	$rootScope.$on('shop-cart.update', function() {
		$scope.getSummary($scope.useGiftCard);
	});

});